module.exports = __webpack_public_path__ + "img/logo-lecard.48e043f0.png";